"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Projects() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="15947" id="projects-weve-delivered" className="bg-background text-foreground py-20 md:py-32 px-5 md:px-8 overflow-hidden">
      <div className="max-w-[1240px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={leftRef} className="lg:col-span-7 order-2 lg:order-1" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 620ms cubic-bezier(0.22, 0.61, 0.36, 1), transform 620ms cubic-bezier(0.22, 0.61, 0.36, 1)"
        }}>
            {}
            <div className="flex flex-col gap-3 mb-8">
              <span className="font-default text-xs font-semibold uppercase" style={{
              letterSpacing: "0.16em",
              color: "var(--primary)",
              lineHeight: 1
            }}>
                Our Portfolio
              </span>
              <span className="block h-px bg-primary" style={{
              width: leftVisible ? "48px" : "0px",
              transition: "width 520ms cubic-bezier(0.22, 0.61, 0.36, 1) 200ms"
            }} aria-hidden="true" />
            </div>

            {}
            <h1 className="font-default text-foreground" style={{
            fontSize: "clamp(2.75rem, 5.6vw, 5.25rem)",
            fontWeight: 600,
            letterSpacing: "-0.022em",
            lineHeight: 1.02
          }}>
              From complex infrastructure to{" "}
              <span style={{
              fontStyle: "italic"
            }}>landmark</span> developments.
            </h1>

            {}
            <p className="font-default mt-6 max-w-[560px] text-muted-foreground" style={{
            fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
            fontWeight: 400,
            letterSpacing: "-0.005em",
            lineHeight: 1.6
          }}>
              Our portfolio spans urban residential towers, sustainable commercial hubs, and critical public infrastructure—every project executed with precision and long-term value in mind. Each development is tailored to its unique environment, ensuring architectural excellence and community impact for generations to come.
            </p>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-5 order-1 lg:order-2 relative lg:-mr-5 md:-mr-8" style={{
          opacity: rightVisible ? 1 : 0,
          transition: "opacity 800ms cubic-bezier(0.22, 0.61, 0.36, 1)"
        }}>
            <div className="relative w-full overflow-hidden rounded-lg max-h-[56vh] lg:max-h-none shadow-lg" style={{
            aspectRatio: "4 / 5"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/urban_development_showcase.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/urban_development_showcase.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/urban_development_showcase.webp-wvc-sizes" alt="Modern architectural project featuring sustainable urban design and glass facade at dusk" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}